export class RecurrenceUnit {
    static EMPTY = 'Empty';
    static DAYS = 'Days';
    static WEEKS = 'Weeks';
    static MONTHS = 'Months';
}
